import type { Lead } from '../types/leadScript';

export const lead: Lead = {
  firstName: 'James',
  lastName: 'Carter',
  userFirstName: 'Jordan',
  userFullName: 'Jordan Miles',
  loanType: 'VA',
  lenderName: 'Rocket Mortgage',
  interestRate: '7.25',
  mortgageBalance: '$248,000',
  firstMortgageBalance: '$248,000',
  propertyAddress: '1428 Maple Ridge Dr',
  propertyCity: 'San Antonio',
  propertyState: 'TX',
  creditCardDebt: '$18,400',
  loanAmount: '$425,000',
};
